import React from 'react';
import { Chip, type ChipProps } from '@mui/material';

const STATUS_MAP: Record<string, { label: string; color: ChipProps['color'] }> = {
  ACTIVE: { label: 'Active', color: 'success' },
  OPEN: { label: 'Open', color: 'success' },
  CLOSED: { label: 'Closed', color: 'default' },
  COMPLETED: { label: 'Completed', color: 'default' },
  WRITTEN_OFF: { label: 'Written off', color: 'warning' },
  INACTIVE: { label: 'Inactive', color: 'default' },
  CREATED: { label: 'Created', color: 'info' },
  PENDING: { label: 'Pending', color: 'warning' },
  OVERDUE: { label: 'Overdue', color: 'error' },
  DEFAULTED: { label: 'Defaulted', color: 'error' },
  GOOD: { label: 'Good', color: 'success' },
  BLOCKED: { label: 'Blocked', color: 'error' },
};

export interface StatusBadgeProps {
  status?: string | null;
  size?: ChipProps['size'];
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'small' }) => {
  const key = (status || '').toUpperCase().trim();
  const mapped = STATUS_MAP[key];
  return (
    <Chip
      size={size}
      label={mapped?.label ?? (status || 'Unknown')}
      color={mapped?.color ?? 'default'}
      variant="outlined"
      sx={{ fontWeight: 600 }}
    />
  );
};

export default StatusBadge;
